import React, { Fragment } from 'react';
import DisplayCode1 from '../../../../components/DisplayCode1/displayCode1';
import DisplayCode2 from '../../../../components/DisplayCode2/DisplayCode2';
import DisplayCodeKo from '../../../../components/DisplayCodeKo/DisplayCodeKo';

const OTP_v = () => {

  const codes = {
    answe_ok1: {
      title: "Answer ok",
      type: "json",
      code: `{
        "status": <boolean>,
        "signed": <boolean>,
        "signature_key": <string>,
        "elapsed": <float>
    }`,
      copied: false
    }
  };

  const codesMutiple = {
    selected: {
      id: "python",
      type: "python",
      code: ` import requests
    url = "URL_BASE/ws/util.py/validate_otp"
    payload = {'country_code': 'MX',
    'user_id': '4532',
    'phone_number': '7229063245',
    'otp': '123456',
    'signature': '277b62946d7ed08cf23a5613e3becc4711322abd'}
    files = []
    headers= {}
    response = requests.request("POST", url, headers=headers, data = payload, files = files)
    print(response.text.encode('utf8'))`
    },
    options: [
      {
        id: "python",
        type: "python",
        code: ` import requests
    url = "URL_BASE/ws/util.py/validate_otp"
    payload = {'country_code': 'MX',
    'user_id': '4532',
    'phone_number': '7229063245',
    'otp': '123456',
    'signature': '277b62946d7ed08cf23a5613e3becc4711322abd'}
    files = []
    headers= {}
    response = requests.request("POST", url, headers=headers, data = payload, files = files)
    print(response.text.encode('utf8'))`
      },
      {
        id: "nodejs",
        type: "javascript",
        code: ` var request = require('request');
  var options = {
  'method': 'POST',
  'url': 'URL_BASE/ws/util.py/validate_otp',
  'headers': {},
  formData: {
  'country_code': 'MX',
  'user_id': '4532',
  'phone_number': '7229063245',
  'otp': '123456',
  'signature': '277b62946d7ed08cf23a5613e3becc4711322abd'
  }
  };
  request(options, function (error, response) { 
  if (error) throw new Error(error);
  console.log(response.body);
  });`
      },
      {
        id: "javascript",
        type: "javascript",
        code: ` var formdata = new FormData();
  formdata.append("country_code", "MX");
  formdata.append("user_id", "4532");
  formdata.append("phone_number", "7229063245");
  formdata.append("otp", "123456");
  formdata.append("signature", "277b62946d7ed08cf23a5613e3becc4711322abd");
  var requestOptions = {
  method: 'POST',
  body: formdata,
  redirect: 'follow'
  };
  fetch("URL_BASE/ws/util.py/validate_otp", requestOptions)
  .then(response => response.text())
  .then(result => console.log(result))
  .catch(error => console.log('error', error));`
      },
      {
        id: "curl",
        type: "bash",
        code: ` curl --location --request POST 'URL_BASE/ws/util.py/validate_otp' 
          --form 'country_code=MX' 
          --form 'user_id=4532' 
          --form 'phone_number=7229063245' 
          --form 'otp=123456' 
          --form 'signature=277b62946d7ed08cf23a5613e3becc4711322abd'`
      }
    ]
  }

  return (
    <Fragment>
      <div className='container-fluid row'>
        <div className='col-md-7'>
          <h1 >OTP &#40;Validation&#41;</h1>
          <p>This service is used to validate an OTP sent to a telephone number.</p>
          <p>
            <span className="label post">POST:</span>
            <span> </span> <code>URL_BASE + /ws/util.py/validate_otp</code>
          </p>
          <h2 >Receives:</h2>
          <p>
            All the parameters that the service receives must be indicated in the body
            of the request.
          </p>
          <div className='overflow-auto'>

            <table>
              <thead>
                <tr>
                  <th align="left">Parameter</th>
                  <th align="center">Format</th>
                  <th align="center">Obligatory</th>
                  <th align="center">Description</th>
                  <th align="center">Default value</th>
                  <th align="center">Example</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td align="left">country_code</td>
                  <td align="center">
                    ISO 3166 alpha-2 &#40;
                    <a href="https://www.iso.org/glossary-for-iso-3166.html">
                      https://www.iso.org/glossary-for-iso-3166.html
                    </a>
                    &#41;
                  </td>
                  <td align="center">Yes</td>
                  <td align="center">Country code where the user resides</td>
                  <td align="center">N/A</td>
                  <td align="center">ES &#40;Spain&#41;</td>
                </tr>
                <tr>
                  <td align="left">user_id</td>
                  <td align="center">Integer</td>
                  <td align="center">Yes</td>
                  <td align="center">
                    Identifier of the user making the request &#40;administrator&#41;
                  </td>
                  <td align="center">N/A</td>
                  <td align="center">4532</td>
                </tr>
                <tr>
                  <td align="left">session_id</td>
                  <td align="center">String</td>
                  <td align="center">
                    Yes &#40;if you do not send signature to &#39;Access
                    Service&#39;&#41;
                  </td>
                  <td align="center">
                    Obtained by identifying the user with ID with user_id on the
                    platform
                  </td>
                  <td align="center">N/A</td>
                  <td align="center">385-XadgYoWixbzN_wqWc3Yyog==</td>
                </tr>
                <tr>
                  <td align="left">signature</td>
                  <td align="center">String</td>
                  <td align="center">
                    Yes &#40;if you do not send session_id &#39;Access Service&#39;&#41;
                  </td>
                  <td align="center">
                    Enables to sign the request without having to log in
                  </td>
                  <td align="center">N/A</td>
                  <td align="center">00d4c87a1dd9c87ccda8518bb007835a71233069</td>
                </tr>
                <tr>
                  <td align="left">phone_number</td>
                  <td align="center">String</td>
                  <td align="center">Yes</td>
                  <td align="center">Phone number to which we want to send the OTP</td>
                  <td align="center">N/A</td>
                  <td align="center">7229063245</td>
                </tr>
                <tr>
                  <td align="left">otp</td>
                  <td align="center">String</td>
                  <td align="center">Yes</td>
                  <td align="center">OTP received by SMS sent to the phone</td>
                  <td align="center">N/A</td>
                  <td align="center">123456</td>
                </tr>
              </tbody>
            </table>
          </div>
          <h2 >Returns:</h2>
          <p>
            Depending on the result of the operation, this service can return two
            different JSON:
          </p>
          <h3 >Answer JSON OK:</h3>

          <div className='mb-3'>
            <DisplayCode1 codeToshow={codes.answe_ok1} />
          </div>
          <h2 >Where:</h2>
          <ul>
            <li>
              <code>status:</code> Shows if the call has been successful
              &#40;true&#41; or not &#40;false&#41;.
            </li>
            <li>
              <code>signed:</code> Shows if the validation request is right or not.
            </li>
            <li>
              <code>signature_key:</code> Key to OTP verification.
            </li>
            <li>
              <code>amount:</code> Operation amount in the suitable format.
            </li>
          </ul>
          <h3 >Answer JSON KO:</h3>

          <div className='mb-3'>
            <DisplayCodeKo />
          </div>

          <h2 >Business logic:</h2>
          <p>
            This service must be used by an user with administrator profile. The OTP
            sent to the indicated phone is validated.
          </p>

        </div>
        <div className='col-md-5'>
          <h2 >Example requests:</h2>
          <div className='effectStickySections'>

            <div className='mb-3'>
              <DisplayCode2 codeToshow={codesMutiple} />
            </div>

          </div>

        </div>

      </div>

    </Fragment>
  );
}
export default OTP_v;
